import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import "./dialog.script";
export function RuiDialogTitle({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-dialog-title": true,
    "data-ref": "title",
    class: cx("rui-dialog__title", className),
    children
  });
}
export function RuiDialogBody({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-dialog-body": true,
    "data-ref": "description",
    class: cx("rui-dialog__body", className),
    children
  });
}
export function RuiDialogActions({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-dialog__actions", className),
    children
  });
}
export function RuiDialogClose({
  children,
  class: className,
  aria,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Close"),
    type: "button",
    "data-dialog-close": true,
    "data-ref": "close",
    class: cx("rui-dialog__close", className),
    children: children ?? "\xD7"
  });
}
function DialogShell({
  alert,
  children,
  open
}) {
  return /* @__PURE__ */jsxs("div", {
    "data-ref": "root",
    class: "rui-dialog",
    hidden: open ? void 0 : true,
    children: [/* @__PURE__ */jsx("div", {
      "data-ref": "backdrop",
      class: "rui-dialog__backdrop"
    }), /* @__PURE__ */jsx("div", {
      "data-ref": "dialog",
      class: "rui-dialog__surface",
      tabindex: -1,
      role: alert ? "alertdialog" : "dialog",
      "aria-modal": "true",
      children
    })]
  });
}
export function RuiDialog({
  title,
  actions,
  children,
  open,
  alert,
  ...props
}) {
  if (title != null || actions != null) {
    return /* @__PURE__ */jsx("rui-dialog", {
      ...props,
      open,
      alert,
      children: /* @__PURE__ */jsxs(DialogShell, {
        open,
        alert,
        children: [/* @__PURE__ */jsx(RuiDialogClose, {}), title != null ? /* @__PURE__ */jsx(RuiDialogTitle, {
          children: title
        }) : null, children != null ? /* @__PURE__ */jsx(RuiDialogBody, {
          children
        }) : null, actions != null ? /* @__PURE__ */jsx(RuiDialogActions, {
          children: actions
        }) : null]
      })
    });
  }
  return /* @__PURE__ */jsx("rui-dialog", {
    ...props,
    open,
    alert,
    children: /* @__PURE__ */jsx(DialogShell, {
      open,
      alert,
      children
    })
  });
}